module.exports = __webpack_public_path__ + "static/media/toronto.f46a678a.png";